import axios from "axios";
import getEnv from "../config/env";

const api = axios.create({
  baseURL: getEnv("VUE_APP_API"),
});

export default api;
